const ChooseOrderType = () => {
    return ( 
        <div className="displayOrders" id='welcomeTheme'>
            <h3>Wybierz status zamówienia aby rozpocząć...</h3>
        </div>
     );
}
 
export default ChooseOrderType;